import { routeChunkKey } from '../routing/prefetchRoute';

/**
 * Stable key per lazy `import()` chunk — matches `prefetchRoute` / `App.tsx` lazy boundaries.
 * Sub-routes under the same page (e.g. `/orders/:id` → `/orders`, procurement tabs) keep the same key
 * so `AdminShell` Suspense does not tear down the whole page tree.
 */
export function adminOutletKey(pathname: string): string {
  return routeChunkKey(pathname);
}
